const initialState = {};

const maintenanceReducer = (state = initialState, { payload }) => {
  if (payload?.code === 503) {
    return { underMaintenance: true, ...payload };
  }

  return state;
};

export default maintenanceReducer;
